<section>
    <div *ngFor="let promo of legacyPromoDetails?.allPromoContent; let i = index" class="promo-banner"
        [ngClass]="promo.type === 'notification' ? 'banner-blue' : 'banner-grey'">

        <div class="banner-content">
            <xm-media-image [imageOptions]="getPromoIcon(promo.icon)" size="width" class="banner-icon">
            </xm-media-image>
            <div class="banner-text">
                <h3 *ngIf="promo.header" class="banner-header">{{promo.header}}</h3>
                <ul class="promo-list">
                    <li *ngFor="let content of promo.promotionContent">
                        {{content}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>
